import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const RouteMasker = () => {
  const location = useLocation();

  useEffect(() => {
    window.history.replaceState({}, "", "/");
  }, [location]);

  return null;
};

export default RouteMasker;
